import { cn } from "@/lib/utils";

const LoadingSpinner = ({
  className,
  color = "currentColor",
  size = 24,
}: {
  className?: string;
  color?: string;
  size?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={String(size)}
    height={String(size)}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={cn("animate-spin", className)}
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);
export default LoadingSpinner;
